module.exports = __webpack_public_path__ + "static/media/satori.88cf6d65.png";